import React, { useState, useEffect, useRef, forwardRef } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import DialogTitle from "@mui/material/DialogTitle";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import Cookies from "universal-cookie";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";

import {
  PdfViewerComponent,
  Toolbar,
  FormFields,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  TextSearch,
  Inject,
  Annotation,
} from "@syncfusion/ej2-react-pdfviewer";
import {
  ToolbarComponent,
  ItemsDirective,
  ItemDirective,
} from "@syncfusion/ej2-react-navigations";
import { DropDownList } from "@syncfusion/ej2-dropdowns";

import "../documents/pdfViewerStyles.css";

import {
  loadReportSignatures,
  loadReport,
} from "../_redux/actions/documentActions";
import { PageLoader } from "@/_components";
import { GreenButton, ExitButton } from "@/_helpers/customMUI";
import SelectSignature from "./SelectSignature";
// import SelectSignature from "../documents/SelectSignature";

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.down("sm")]: {
      paddingTop: theme.spacing(1),
      paddingRight: theme.spacing(1),
      paddingBottom: theme.spacing(2),
    },
  },
  xsToolbarHeight: {
    [theme.breakpoints.down("sm")]: { height: 50 },
  },
  actionButton: {
    backgroundColor: "#9dba79",
    "&:hover": {
      backgroundColor: "#84a957",
    },
    borderRadius: 5,
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    color: "#fff",
    marginTop: 5,
    fontWeight: 600,
  },
  signSubmitClass: {
    backgroundColor: "#9dba79",
    "&:hover": {
      backgroundColor: "#84a957",
    },
    borderRadius: 5,
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    color: "#fff",
    marginTop: 5,
    fontWeight: 300,
  },
  pdfHeader: {
    [theme.breakpoints.up("sm")]: { width: "60vw" },
    [theme.breakpoints.down("sm")]: { width: "100vw" },
  },
  pdfContainer: {
    [theme.breakpoints.up("sm")]: { height: "100px" },
    //[theme.breakpoints.down("lg")]: { height: "20%" },
  },
}));

const zoomData = [
  { value: "10", text: "10%" },
  { value: "25", text: "25%" },
  { value: "50", text: "50%" },
  { value: "75", text: "75%" },
  { value: "100", text: "100%" },
  { value: "125", text: "125%" },
  { value: "150", text: "150%" },
  { value: "200", text: "200%" },
  { value: "400", text: "400%" },
];

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const svcUrl = process.env.API_URL + "/pdfViewer";
//const svcUrl =
//  "https://ej2services.syncfusion.com/production/web-services/api/pdfviewer";

function Review({
  iDocID,
  appointmentID,
  jurisdictionID,
  locationID,
  reportType,
  reportName,
  vehicleID,
  handleClose,
  saveReportSignature,
  saveCompletedReport,
  reportSignatures,
  loadReportSignatures,
  report,
  loadReport,
  user,
}) {
  //   const [user,setUser]=useState(
  //     {
  //   "userId": 10416,
  //   "clientID": 11463003201,
  //   "email": "9877623455@lifesafer.com",
  //   "firstName": "Tt",
  //   "lastName": "tt",
  //   "locationID": 1463,
  //   "jurisdictionID": 31,
  //   "cC_APIKey": "RDR8U6NA",
  //   "jwtToken": null,
  //   "isFranchise": false,
  //   "languageID": 1,
  //   "reportSignatureId": -1,
  //   "installed": false,
  //   "ccEnabled": true,
  //   "autoPayEnabled": true,
  //   "phoneNumber": "9877623455",
  //   "isTest": false
  // }
  //   )


  const cookies = new Cookies();
  // const user = cookies.get("lifesaferUser");
  const classes = useStyles();
  const isMountedRef = useRef(null);
  const { t } = useTranslation();
  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [totPageCount, setTotPageCount] = useState(0);
  const [documentLoaded, setDocumentLoaded] = useState(false);
  const [signaturePopup, setSignaturePopup] = useState(false);
  // const [selectedSignatureId, setSelectedSignatureId] = useState(
  //   user?.reportSignatureId > 0 ? user?.reportSignatureId : 0
  // );

  const [selectedSignatureId, setSelectedSignatureId] = useState(
    user?.reportSignatureId
  );

  const [catchingReport, setCatchingReport] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const isSmallScreen = screenWidth <= 768;
  const theme = useTheme();
  const isXtraSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const isMobile = detectMob();

  useEffect(() => {
    isMountedRef.current = true;
    if (
      reportSignatures === null ||
      reportSignatures === undefined ||
      reportSignatures[0].CurrentState === "Undefined"
    ) {
      if (isMountedRef.current) {
        loadReportSignatures().catch((error) => {
          console.log("Loading report signatures failed! " + error);
        });
      }
    }
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  useEffect(() => {
    if (
      reportSignatures === undefined ||
      reportSignatures[0] === undefined ||
      reportSignatures[0].CurrentState === "Undefined"
    ) {
      loadReportSignatures();
    }
  }, [reportSignatures]);

  useEffect(() => {
    if (
      report !== null &&
      report[0] !== undefined &&
      report[0].CurrentState !== "Undefined" &&
      report[0].CurrentState !== "None" &&
      report[0].id !== 0
    ) {
      var viewer =
        document.getElementById("pdfViewerContainer").ej2_instances[0];
      viewer.serviceUrl = svcUrl;
      viewer.dataBind();
      viewer.load(`data:application/pdf;base64,${report[0].pdfDocument}`);
    } else if (catchingReport === false) {
      setCatchingReport(true);
      let currentData = {
        clientID: user?.clientID,
        appointmentID: appointmentID,
        jurisdictionID: jurisdictionID,
        locationID: locationID,
        reportId: iDocID,
        languageID: user?.languageID,
        vehicleID: vehicleID,
      };
      loadReport(currentData).catch((err) => {
        toast.error(t("documents.loadDocumentFailed") + " " + err.message);
      });
    }
  }, [report]);

  function handleWindowSizeChange() {
    setScreenWidth(window.innerWidth);
  }

  const handleSignatureOpen = () => setSignaturePopup(true);
  const onCancel = () => {
    user?.reportSignatureId > 0
      ? user?.reportSignatureId
      : setSelectedSignatureId(0);
    setSignaturePopup(false);
  };
  const handleSaveSignature = async () => {
    if (user !== null) {
      let currentData = {
        userId: parseInt(user?.userId),
        reportSignatureId: parseInt(selectedSignatureId),
      };
      saveReportSignature(currentData);

      // Update User Cookie with SignatureId
      let newInfo = {
        reportSignatureId: parseInt(selectedSignatureId),
      };
      let updatedUser = {
        ...user,
        ...newInfo,
      };
      cookies.set("lifesaferUser", JSON.stringify(updatedUser), {
        path: "/",
        sameSite: "strict",
      });

      submitForm();
    }
    setSignaturePopup(false);
  };

  const zoomToTemplate = new DropDownList({
    dataSource: zoomData,
    width: 120,
    index: 4,
    change: handleZoomChange,
    id: "ddlZoomTo",
  });

  function closeTemplate() {
    return (
      <ExitButton
        size="small"
        variant="contained"
        style={{ minWidth: 64, height: 24 }}
      >
        {t("buttons.closeButton")}
      </ExitButton>
    );
  }

  function submitTemplate() {
    return (
      <GreenButton size="small" variant="contained" style={{ height: 26 }}>
        {isXtraSmall
          ? t("documents.signAndSubmitSM")
          : t("documents.signAndSubmit")}
      </GreenButton>
    );
  }

  function reviewTemplate() {
    return (
      <GreenButton size="small" variant="contained" style={{ height: 26 }}>
        {t("documents.reviewed")}
      </GreenButton>
    );
  }

  const onPageChange = () => {
    let viewer = document.getElementById("pdfViewerContainer").ej2_instances[0];
    if (viewer !== null && viewer !== undefined) {
      setCurrentPageNumber(viewer.currentPageNumber);
    }
  };

  function submitForm() {
    if (
      reportType === "SignatureReports" &&
      (selectedSignatureId === null ||
        selectedSignatureId === undefined ||
        selectedSignatureId <= 0)
    ) {
      handleSignatureOpen();
    } else {
      setDocumentLoaded(false);
      //model.UserId, model.ClientID, model.VehicleID, model.AppointmentID,
      //model.JurisdictionID, model.ReportID, Path.Combine(dirPath, sFullFileName)
      //sign or view the document
      let newReportName = reportName.replace(/\.[^/.]+$/, "");
      newReportName = newReportName.replaceAll(" ", "_");
      let currentData = {
        userId: user?.userId,
        clientID: user?.clientID,
        vehicleID: vehicleID,
        reportID: iDocID,
        appointmentID: appointmentID,
        jurisdictionID: jurisdictionID,
        locationID: locationID,
        languageID: user?.languageID,
        reportName: newReportName,
        reportType: reportType,
      };
      saveCompletedReport(currentData);
    }
  }

  function handleZoomChange(event) {
    let iZoomTo = event.itemData.value;
    let viewer = document.getElementById("pdfViewerContainer");
    if (viewer !== null && viewer !== undefined && iZoomTo > 0) {
      viewer.ej2_instances[0].magnification.zoomTo(iZoomTo);
    }
  }

  const handleDocumentLoaded = () => {
    setDocumentLoaded(true);
    setCurrentPageNumber(1);

    let pdfViewer = document.getElementById("pdfViewerContainer");
    if (pdfViewer !== null && pdfViewer !== undefined) {
      setTotPageCount(pdfViewer.ej2_instances[0].pageCount);
    }
  };

  function clickHandler(args) {
    let viewer = document.getElementById("pdfViewerContainer");
    switch (args.item.id) {
      case "back":
        handleClose();
        break;
      case "file_Open":
        document.getElementById("fileUpload").click();
        break;
      case "previousPage":
        viewer.ej2_instances[0].navigation.goToPreviousPage();
        break;
      case "nextPage":
        viewer.ej2_instances[0].navigation.goToNextPage();
        break;
      case "print":
        viewer.ej2_instances[0].print.print();
        break;
      case "download":
        viewer.ej2_instances[0].download();
        break;
      case "fit_to_page":
        viewer.ej2_instances[0].magnification.fitToPage();
        break;
      case "zoom_in":
        viewer.ej2_instances[0].magnification.zoomIn();
        showZoomPercentage();
        break;
      case "zoom_out":
        viewer.ej2_instances[0].magnification.zoomOut();
        showZoomPercentage();
        break;
      case "submitForm":
        submitForm();
        break;
      case "reviewDoc":
        submitForm();
        break;
    }
  }

  function showZoomPercentage() {
    let viewer = document.getElementById("pdfViewerContainer");
    if (viewer !== null && viewer !== undefined) {
      if (viewer.ej2_instances[0].magnification.zoomFactor > 0) {
        let ddlZoomTo = document.getElementById("ddlZoomTo");
        if (ddlZoomTo !== null && ddlZoomTo !== undefined) {
          ddlZoomTo.value =
            viewer.ej2_instances[0].magnification.zoomFactor * 100 + "%";
        }
      }
    }
  }

  function detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }
  return (
    <>
      <div className={classes.mainContainer}>
        <Grid container item className={classes.pdfHeader}>
          <Grid
            container
            item
            direction="row"
            className={classes.headerGrid}
            justifyContent="flex-end"
            xs={10}
          >
            {reportType === "SignatureReports" ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  fontSize: "small",
                }}
              >
                {t("documents.warning")}
              </div>
            ) : reportType === "NonSignatureReports" ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  fontSize: "small",
                }}
              >
                {t("documents.warningNonSignature")}
              </div>
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
        {documentLoaded === false ? (
          <></>
        ) : (
          <div className="e-pdf-toolbar" style={{ height: "50px" }}>
            <ToolbarComponent
              id="customToolbar"
              clicked={(e) => clickHandler(e)}
            >
              {isSmallScreen ? (
                <ItemsDirective>
                  {reportType === "SignatureReports" ? (
                    <ItemDirective
                      type="input"
                      align="Left"
                      disabled={
                        currentPageNumber === totPageCount ? false : true
                      }
                      id="submitForm"
                      template={submitTemplate}
                    ></ItemDirective>
                  ) : reportType === "NonSignatureReports" ? (
                    <ItemDirective
                      id="reviewDoc"
                      align="Left"
                      disabled={
                        currentPageNumber === totPageCount ? false : true
                      }
                      template={reviewTemplate}
                    ></ItemDirective>
                  ) : (
                    <></>
                  )}
                  <ItemDirective
                    prefixIcon="e-pv-previous-page-navigation-icon"
                    id="previousPage"
                    tooltipText="Previous Page"
                    align="Center"
                    disabled={currentPageNumber === 1}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-icons e-pv-next-page-navigation-icon"
                    id="nextPage"
                    tooltipText="Next Page"
                    align="Center"
                    disabled={currentPageNumber === totPageCount}
                  ></ItemDirective>
                  <ItemDirective
                    id="currentPage"
                    tooltipText="Current Page"
                    text={currentPageNumber + " of " + totPageCount}
                    align="Center"
                  ></ItemDirective>
                  <ItemDirective
                    type="Separator"
                    className="e-toolbar-item e-separator"
                    align="Center"
                  />
                  <ItemDirective
                    prefixIcon="e-pv-zoom-out-sample"
                    id="zoom_out"
                    align="Center"
                    tooltipText="Zoom out"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-zoom-in-icon"
                    id="zoom_in"
                    align="Center"
                    tooltipText="Zoom in"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-print-document-icon"
                    tooltipText="Print"
                    id="print"
                    align="Right"
                    visible={isMobile === false}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-download-document-icon"
                    tooltipText="Download"
                    id="download"
                    align="Right"
                    visible={isMobile === false}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-back-page-navigation-icon"
                    id="back"
                    tooltipText="Close"
                    align="Right"
                    template={closeTemplate}
                  />
                </ItemsDirective>
              ) : (
                <ItemsDirective>
                  <ItemDirective
                    prefixIcon="e-pv-back-page-navigation-icon"
                    id="back"
                    tooltipText="Back"
                    align="Left"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-previous-page-navigation-icon"
                    id="previousPage"
                    tooltipText="Previous Page"
                    align="Center"
                    disabled={currentPageNumber === 1}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-icons e-pv-next-page-navigation-icon"
                    id="nextPage"
                    tooltipText="Next Page"
                    align="Center"
                    disabled={currentPageNumber === totPageCount}
                  ></ItemDirective>
                  <ItemDirective
                    id="currentPage"
                    tooltipText="Current Page"
                    text={currentPageNumber + " of " + totPageCount}
                    align="Center"
                  ></ItemDirective>
                  <ItemDirective
                    type="Separator"
                    className="e-toolbar-item e-separator"
                    align="Center"
                  />
                  <ItemDirective
                    prefixIcon="e-pv-zoom-out-sample"
                    id="zoom_out"
                    align="Center"
                    tooltipText="Zoom out"
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-zoom-in-icon"
                    id="zoom_in"
                    align="Center"
                    tooltipText="Zoom in"
                  ></ItemDirective>
                  <ItemDirective
                    type="Input"
                    id="ddlZoomTo"
                    template={zoomToTemplate}
                    tooltipText="Zoom To"
                    align="Center"
                  ></ItemDirective>
                  {reportType === "SignatureReports" ? (
                    <ItemDirective
                      type="input"
                      align="Left"
                      disabled={
                        currentPageNumber === totPageCount ? false : true
                      }
                      id="submitForm"
                      template={submitTemplate}
                    ></ItemDirective>
                  ) : reportType === "NonSignatureReports" ? (
                    <ItemDirective
                      id="reviewDoc"
                      align="Left"
                      disabled={
                        currentPageNumber === totPageCount ? false : true
                      }
                      template={reviewTemplate}
                    ></ItemDirective>
                  ) : (
                    <></>
                  )}
                  <ItemDirective
                    prefixIcon="e-pv-print-document-icon"
                    tooltipText="Print"
                    id="print"
                    align="Right"
                    visible={isMobile === false}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-download-document-icon"
                    tooltipText="Download"
                    id="download"
                    align="Right"
                    visible={isMobile === false}
                  ></ItemDirective>
                  <ItemDirective
                    prefixIcon="e-pv-back-page-navigation-icon"
                    id="back"
                    tooltipText="Close"
                    align="Right"
                    template={closeTemplate}
                  />
                </ItemsDirective>
              )}
            </ToolbarComponent>
          </div>
        )}
        <PdfViewerComponent
          id="pdfViewerContainer"
          downloadFileName={reportName}
          serviceUrl={svcUrl}
          pageChange={onPageChange}
          documentLoad={handleDocumentLoaded}
          enableToolbar={false}
          enableNavigationToolbar={false}
        >
          <Inject
            services={[
              Toolbar,
              Magnification,
              Navigation,
              LinkAnnotation,
              BookmarkView,
              ThumbnailView,
              Print,
              TextSelection,
              TextSearch,
              Annotation,
              FormFields,
            ]}
          />
        </PdfViewerComponent>
      </div>
      <div>
        <Grid container direction="row">
          <Grid item>
            <Dialog
              open={signaturePopup}
              TransitionComponent={Transition}
              keepMounted
              onClose={() => setSignaturePopup(false)}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle
                id="form-dialog-title"
                style={{ backgroundColor: "#1c355e", color: "#fff" }}
              >
                {t("documents.signatureTitle")}
              </DialogTitle>
              <DialogContent>
                <DialogContentText style={{ color: "black" }}>
                  {t("documents.legalName")}
                </DialogContentText>
                <DialogContentText>{user?.clientName}</DialogContentText>
                <div style={{ textAlign: "right" }}>
                  <Button
                    component={Link}
                    to="../profile/personalEdits/EditName"
                    color="primary"
                  >
                    {t("documents.update")}
                  </Button>
                </div>
                <Divider />
                <DialogContentText>
                  {t("documents.agreementPartI")}
                  <Link
                    to={"../src/_guides/ElectronicSignatureAgreement.pdf"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t("documents.esa")}
                  </Link>
                  {t("documents.agreementPartII")}
                </DialogContentText>
                <Divider />
                <div>
                  {reportSignatures === null ||
                  reportSignatures === undefined ||
                  reportSignatures[0].CurrentState === "Undefined" ? (
                    <div>
                      <PageLoader />
                    </div>
                  ) : (
                    <SelectSignature
                      reportSignatures={reportSignatures}
                      user={user}
                      selectedSignatureId={selectedSignatureId.toString()}
                      setSelectedSignatureId={setSelectedSignatureId}
                    />
                  )}
                </div>
                <Divider />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleSaveSignature}
                  className={classes.actionButton}
                >
                  {t("documents.adoptSignature")}
                </Button>
                <Button onClick={onCancel} color="primary">
                  {t("documents.cancel")}
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

Review.propTypes = {
  iDocID: PropTypes.number.isRequired,
  reportType: PropTypes.string,
  reportName: PropTypes.string,
  handleClose: PropTypes.func.isRequired,
  loadReportSignatures: PropTypes.func.isRequired,
  reportSignatures: PropTypes.array,
  saveReportSignature: PropTypes.func.isRequired,
  saveCompletedReport: PropTypes.func.isRequired,
  appointmentID: PropTypes.number,
  vehicleID: PropTypes.number,
  jurisdictionID: PropTypes.number,
  locationID: PropTypes.number,
  report: PropTypes.array,
  loadReport: PropTypes.func.isRequired,
  user: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    reportSignatures: state.reportSignatures,
    report: state.report,
  };
}

const mapDispatchToProps = {
  loadReportSignatures,
  loadReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(Review);
